module.exports = __webpack_public_path__ + "img/TOYOTASUBARU.0e07fe7.jpg";